"use strict";

var _toConsumableArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _slicedToArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var React = require("react");

var core_1 = require("../../core");

var utils_1 = require("../utils");

var chart_component_1 = require("../../container/chart_component");

var graphics_1 = require("../../core/graphics"); // adapted from https://stackoverflow.com/a/20820649


function desaturate(color, amount) {
  var r = color.r,
      g = color.g,
      b = color.b;
  var l = 0.3 * r + 0.6 * g + 0.1 * b;
  return {
    r: Math.min(r + amount * (l - r), 255),
    g: Math.min(g + amount * (l - g), 255),
    b: Math.min(b + amount * (l - b), 255)
  };
}

var srgb2lab = core_1.getColorConverter("sRGB", "lab");
var lab2srgb = core_1.getColorConverter("lab", "sRGB");

function modifyNumber(value, modifier) {
  if (modifier.set != null) {
    return modifier.set;
  } else {
    if (modifier.multiply != null) {
      value *= modifier.multiply;
    }

    if (modifier.add != null) {
      value += modifier.add;
    }

    if (modifier.pow != null) {
      value = Math.pow(value, modifier.pow);
    }

    return value;
  }
}

function applyColorFilter(color, colorFilter) {
  var _srgb2lab = srgb2lab(color.r, color.g, color.b),
      _srgb2lab2 = _slicedToArray(_srgb2lab, 3),
      L = _srgb2lab2[0],
      A = _srgb2lab2[1],
      B = _srgb2lab2[2];

  if (colorFilter.saturation) {
    var s = Math.sqrt(A * A + B * B);
    var sPrime = modifyNumber(s, colorFilter.saturation);

    if (s == 0) {
      A = 0;
      B = 0;
    } else {
      A *= sPrime / s;
      B *= sPrime / s;
    }
  }

  if (colorFilter.lightness) {
    L = modifyNumber(L / 100, colorFilter.lightness) * 100;
  }

  var _lab2srgb = lab2srgb(L, A, B),
      _lab2srgb2 = _slicedToArray(_lab2srgb, 3),
      r = _lab2srgb2[0],
      g = _lab2srgb2[1],
      b = _lab2srgb2[2];

  return {
    r: r,
    g: g,
    b: b
  };
}

exports.applyColorFilter = applyColorFilter;

function renderColor(color, colorFilter) {
  if (!color) {
    return "rgb(0,0,0)";
  }

  if (colorFilter) {
    color = applyColorFilter(color, colorFilter);
  }

  return "rgb(".concat(color.r.toFixed(0), ",").concat(color.g.toFixed(0), ",").concat(color.b.toFixed(0), ")");
}

exports.renderColor = renderColor;

function renderStyle(style) {
  if (style == null) {
    return {};
  }

  return {
    stroke: style.strokeColor ? renderColor(style.strokeColor, style.colorFilter) : "none",
    strokeOpacity: style.strokeOpacity != undefined ? style.strokeOpacity : 1,
    strokeWidth: style.strokeWidth != undefined ? style.strokeWidth : 1,
    strokeLinecap: style.strokeLinecap != undefined ? style.strokeLinecap : "round",
    strokeLinejoin: style.strokeLinejoin != undefined ? style.strokeLinejoin : "round",
    fill: style.fillColor ? renderColor(style.fillColor, style.colorFilter) : "none",
    fillOpacity: style.fillOpacity != undefined ? style.fillOpacity : 1,
    textAnchor: style.textAnchor != undefined ? style.textAnchor : "start",
    opacity: style.opacity != undefined ? style.opacity : 1
  };
}

exports.renderStyle = renderStyle;
var path_commands = {
  M: function M(args) {
    return "M ".concat(utils_1.toSVGNumber(args[0]), ",").concat(utils_1.toSVGNumber(-args[1]));
  },
  L: function L(args) {
    return "L ".concat(utils_1.toSVGNumber(args[0]), ",").concat(utils_1.toSVGNumber(-args[1]));
  },
  C: function C(args) {
    return "C ".concat(utils_1.toSVGNumber(args[0]), ",").concat(utils_1.toSVGNumber(-args[1]), ",").concat(utils_1.toSVGNumber(args[2]), ",").concat(utils_1.toSVGNumber(-args[3]), ",").concat(utils_1.toSVGNumber(args[4]), ",").concat(utils_1.toSVGNumber(-args[5]));
  },
  Q: function Q(args) {
    return "Q ".concat(utils_1.toSVGNumber(args[0]), ",").concat(utils_1.toSVGNumber(-args[1]), ",").concat(utils_1.toSVGNumber(args[2]), ",").concat(utils_1.toSVGNumber(-args[3]));
  },
  A: function A(args) {
    return "A ".concat(utils_1.toSVGNumber(args[0]), ",").concat(utils_1.toSVGNumber(args[1]), ",").concat(utils_1.toSVGNumber(args[2]), ",").concat(utils_1.toSVGNumber(args[3]), ",").concat(utils_1.toSVGNumber(args[4]), ",").concat(utils_1.toSVGNumber(args[5]), ",").concat(utils_1.toSVGNumber(-args[6]));
  },
  Z: function Z() {
    return "Z";
  }
};

function renderSVGPath(cmds) {
  return cmds.map(function (x) {
    return path_commands[x.cmd](x.args);
  }).join(" ");
}

exports.renderSVGPath = renderSVGPath;

function renderTransform(transform) {
  if (!transform) {
    return null;
  }

  if (Math.abs(transform.angle) < 1e-7) {
    return "translate(".concat(utils_1.toSVGNumber(transform.x), ",").concat(utils_1.toSVGNumber(-transform.y), ")");
  } else {
    return "translate(".concat(utils_1.toSVGNumber(transform.x), ",").concat(utils_1.toSVGNumber(-transform.y), ") rotate(").concat(utils_1.toSVGNumber(-transform.angle), ")");
  }
}

exports.renderTransform = renderTransform;

var TextOnPath =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(TextOnPath, _React$PureComponent);

  function TextOnPath() {
    var _this;

    _classCallCheck(this, TextOnPath);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextOnPath).apply(this, arguments));
    _this.pathID = core_1.uniqueID();
    return _this;
  }

  _createClass(TextOnPath, [{
    key: "render",
    value: function render() {
      return React.createElement("g", null, React.createElement("defs", null, React.createElement("path", {
        id: this.pathID,
        fill: "none",
        stroke: "red",
        d: renderSVGPath(this.props.cmds)
      })), React.createElement("text", {
        style: Object.assign({}, this.props.style, {
          textAnchor: this.props.align
        })
      }, React.createElement("textPath", {
        href: "#".concat(this.pathID),
        startOffset: this.props.align == "start" ? "0%" : this.props.align == "middle" ? "50%" : "100%"
      }, this.props.text)));
    }
  }]);

  return TextOnPath;
}(React.PureComponent);

function getElementClassType(datum) {
  try {
    var data = JSON.parse(datum);

    if (data instanceof Array) {
      data = data[0];
    }

    if (data._TYPE) {
      if (data._TYPE.startsWith("axis-") || data._TYPE == "legend") {
        return ["mark", data._TYPE];
      } else if (data._TYPE == "nested-chart" || data._TYPE == "axis") {
        return [data._TYPE];
      } else {
        return ["mark", data._MARKID, data._TYPE];
      }
    }

    return ["mark"];
  } catch (_a) {
    return [];
  }
}

function renderGraphicalElementSVG(element, options) {
  if (!element) {
    return null;
  }

  if (!options) {
    options = {};
  }

  var style = options.noStyle ? null : renderStyle(options.styleOverride || element.style); // OnClick event handler

  var mouseEvents = {};

  if (element.selectable) {
    style.cursor = "pointer";
    style.pointerEvents = "all";

    if (options.onClick) {
      mouseEvents.onClick = function (e) {
        e.stopPropagation();
        options.onClick(element.selectable, e.nativeEvent);
      };
    }

    if (options.onMouseEnter) {
      mouseEvents.onMouseEnter = function (e) {
        options.onMouseEnter(element.selectable, e.nativeEvent);
      };
    }

    if (options.onMouseLeave) {
      mouseEvents.onMouseLeave = function (e) {
        options.onMouseLeave(element.selectable, e.nativeEvent);
      };
    }
  }

  switch (element.type) {
    case "rect":
      {
        var rect = element;
        var maker = graphics_1.makePath(options.styleOverride || element.style);
        maker.moveTo(rect.x1, rect.y1);
        maker.lineTo(rect.x1, rect.y2);
        maker.lineTo(rect.x2, rect.y2);
        maker.lineTo(rect.x2, rect.y1);
        maker.closePath();
        return React.createElement("path", Object.assign({
          key: options.key
        }, mouseEvents, {
          id: core_1.markID(element["data-datum"]),
          className: [].concat(_toConsumableArray([options.className] || []), _toConsumableArray(element["data-datum"] ? getElementClassType(element["data-datum"]) : [])).join(" "),
          style: style,
          d: renderSVGPath(maker.path.cmds),
          "data-datum": element["data-datum"] || null
        }));
      }

    case "circle":
      {
        var circle = element;

        var _maker = graphics_1.makePath(options.styleOverride || element.style);

        _maker.moveTo(circle.cx - circle.r, circle.cy);

        _maker.arcTo(circle.r, circle.r, 0, 1, 0, circle.cx + circle.r, circle.cy);

        _maker.arcTo(circle.r, circle.r, 0, 1, 0, circle.cx - circle.r, circle.cy);

        _maker.closePath();

        return React.createElement("path", Object.assign({
          key: options.key
        }, mouseEvents, {
          id: core_1.markID(element["data-datum"]),
          className: [].concat(_toConsumableArray([options.className] || []), _toConsumableArray(element["data-datum"] ? getElementClassType(element["data-datum"]) : [])).join(" "),
          style: style,
          d: renderSVGPath(_maker.path.cmds),
          "data-datum": element["data-datum"] || null
        }));
      }

    case "ellipse":
      {
        var ellipse = element;

        var _maker2 = graphics_1.makePath(options.styleOverride || element.style);

        _maker2.moveTo(ellipse.x1, (ellipse.y1 + ellipse.y2) / 2);

        _maker2.arcTo(Math.abs(ellipse.x1 - ellipse.x2) / 2, Math.abs(ellipse.y1 - ellipse.y2) / 2, 0, 1, 0, ellipse.x2, (ellipse.y1 + ellipse.y2) / 2);

        _maker2.arcTo(Math.abs(ellipse.x1 - ellipse.x2) / 2, Math.abs(ellipse.y1 - ellipse.y2) / 2, 0, 1, 0, ellipse.x1, (ellipse.y1 + ellipse.y2) / 2);

        _maker2.closePath();

        return React.createElement("path", Object.assign({
          key: options.key
        }, mouseEvents, {
          id: core_1.markID(element["data-datum"]),
          className: [].concat(_toConsumableArray([options.className] || []), _toConsumableArray(element["data-datum"] ? getElementClassType(element["data-datum"]) : [])).join(" "),
          style: style,
          d: renderSVGPath(_maker2.path.cmds),
          "data-datum": element["data-datum"] || null
        }));
      }

    case "line":
      {
        var line = element;

        var _maker3 = graphics_1.makePath(options.styleOverride || element.style);

        _maker3.moveTo(line.x1, line.y1);

        _maker3.lineTo(line.x2, line.y2);

        return React.createElement("path", Object.assign({
          key: options.key
        }, mouseEvents, {
          id: core_1.markID(element["data-datum"]),
          className: [].concat(_toConsumableArray([options.className] || []), _toConsumableArray(element["data-datum"] ? getElementClassType(element["data-datum"]) : [])).join(" "),
          style: style,
          d: renderSVGPath(_maker3.path.cmds),
          "data-datum": element["data-datum"] || null
        }));
      }

    case "polygon":
      {
        var polygon = element;

        var _maker4 = graphics_1.makePath(options.styleOverride || element.style);

        _maker4.moveTo((polygon.points[0] || {
          x: 0,
          y: 0
        }).x, (polygon.points[0] || {
          x: 0,
          y: 0
        }).y);

        polygon.points.forEach(function (p, i) {
          if (i <= 0) {
            return;
          }

          _maker4.lineTo(p.x, p.y);
        });

        _maker4.closePath();

        return React.createElement("path", Object.assign({
          key: options.key
        }, mouseEvents, {
          id: core_1.markID(element["data-datum"]),
          className: [].concat(_toConsumableArray([options.className] || []), _toConsumableArray(element["data-datum"] ? getElementClassType(element["data-datum"]) : [])).join(" "),
          style: style,
          d: renderSVGPath(_maker4.path.cmds),
          "data-datum": element["data-datum"] || null
        }));
      }

    case "path":
      {
        var path = element;
        var d = renderSVGPath(path.cmds);
        return React.createElement("path", Object.assign({
          key: options.key
        }, mouseEvents, {
          id: core_1.markID(element["data-datum"]),
          className: [].concat(_toConsumableArray([options.className] || []), _toConsumableArray(element["data-datum"] ? getElementClassType(element["data-datum"]) : [])).join(" "),
          style: style,
          d: d,
          "data-datum": element["data-datum"] || null
        }));
      }

    case "text-on-path":
      {
        var text = element;
        style.fontFamily = text.fontFamily;
        style.fontSize = text.fontSize + "px";
        console.log(text);
        return React.createElement(TextOnPath, {
          text: text.text,
          style: style,
          cmds: text.pathCmds,
          align: text.align
        });
      }

    case "text":
      {
        var _text = element;
        style.fontFamily = _text.fontFamily;
        style.fontSize = _text.fontSize + "px";

        if (style.stroke != "none") {
          var style2 = core_1.shallowClone(style);
          style2.fill = style.stroke;
          var e1 = React.createElement("text", Object.assign({}, mouseEvents, {
            id: core_1.markID(element["data-datum"]),
            className: [].concat(_toConsumableArray([options.className] || []), _toConsumableArray(element["data-datum"] ? getElementClassType(element["data-datum"]) : [])).join(" "),
            style: style2,
            x: _text.cx,
            y: -_text.cy,
            "data-datum": element["data-datum"] || null
          }), _text.text);
          style.stroke = "none";
          var e2 = React.createElement("text", Object.assign({}, mouseEvents, {
            id: core_1.markID(element["data-datum"]),
            className: [].concat(_toConsumableArray([options.className] || []), _toConsumableArray(element["data-datum"] ? getElementClassType(element["data-datum"]) : [])).join(" "),
            style: style,
            x: _text.cx,
            y: -_text.cy,
            "data-datum": element["data-datum"] || null
          }), _text.text);
          return React.createElement("g", {
            key: options.key
          }, e1, e2);
        } else {
          return React.createElement("text", Object.assign({
            key: options.key
          }, mouseEvents, {
            id: core_1.markID(element["data-datum"]),
            className: [].concat(_toConsumableArray([options.className] || []), _toConsumableArray(element["data-datum"] ? getElementClassType(element["data-datum"]) : [])).join(" "),
            style: style,
            x: _text.cx,
            y: -_text.cy,
            "data-datum": element["data-datum"] || null
          }), _text.text);
        }
      }

    case "image":
      {
        var image = element;
        var preserveAspectRatio = null;

        switch (image.mode) {
          case "letterbox":
            preserveAspectRatio = "meet";
            break;

          case "stretch":
            preserveAspectRatio = "none";
            break;
        }

        return React.createElement("image", Object.assign({
          key: options.key
        }, mouseEvents, {
          id: core_1.markID(element["data-datum"]),
          className: [].concat(_toConsumableArray([options.className] || []), _toConsumableArray(element["data-datum"] ? getElementClassType(element["data-datum"]) : [])).join(" "),
          style: style,
          preserveAspectRatio: preserveAspectRatio,
          xlinkHref: options.externalResourceResolver ? options.externalResourceResolver(image.src) : image.src,
          x: image.x,
          y: -image.y - image.height,
          width: image.width,
          height: image.height,
          "data-datum": element["data-datum"] || null
        }));
      }

    case "chart-container":
      {
        var component = element;
        var subSelection = options.selection ? {
          isSelected: function isSelected(table, rowIndices) {
            // Get parent row indices from component row indices
            var parentRowIndices = rowIndices.map(function (x) {
              return component.selectable.rowIndices[x];
            }); // Query the selection with parent row indices

            return options.selection.isSelected(component.selectable.plotSegment.table, parentRowIndices);
          }
        } : null;

        var convertEventHandler = function convertEventHandler(handler) {
          if (!handler) {
            return null;
          }

          return function (s, parameters) {
            if (s == null) {
              // Clicked inside the ChartComponent but not on a glyph,
              // in this case we select the whole thing
              handler(component.selectable, parameters);
            } else {
              // Clicked on a glyph of ChartComponent (or a sub-component)
              // in this case we translate the component's rowIndices its parent's
              handler({
                plotSegment: component.selectable.plotSegment,
                glyphIndex: component.selectable.glyphIndex,
                rowIndices: s.rowIndices.map(function (i) {
                  return component.selectable.rowIndices[i];
                })
              }, parameters);
            }
          };
        };

        return React.createElement(chart_component_1.ChartComponent, {
          key: options.key,
          chart: component.chart,
          dataset: component.dataset,
          width: component.width,
          height: component.height,
          rootElement: "g",
          sync: options.chartComponentSync,
          selection: subSelection,
          onGlyphClick: convertEventHandler(options.onClick),
          onGlyphMouseEnter: convertEventHandler(options.onMouseEnter),
          onGlyphMouseLeave: convertEventHandler(options.onMouseLeave),
          rendererOptions: {
            chartComponentSync: options.chartComponentSync,
            externalResourceResolver: options.externalResourceResolver
          }
        });
      }

    case "group":
      {
        var group = element;
        return React.createElement("g", Object.assign({
          transform: renderTransform(group.transform),
          key: group.key || options.key,
          style: {
            opacity: group.style && group.style.opacity != null ? group.style.opacity : 1
          },
          id: core_1.markID(element["data-datum"]),
          className: getElementClassType(element["data-datum"]).join(" "),
          "data-datum": element["data-datum"] && (element["data-datum"].startsWith("{") || element["data-datum"].startsWith("[")) ? element["data-datum"] : null
        }, mouseEvents), group.elements.map(function (x, index) {
          return renderGraphicalElementSVG(x, {
            key: "m".concat(index),
            chartComponentSync: options.chartComponentSync,
            externalResourceResolver: options.externalResourceResolver,
            onClick: options.onClick,
            onMouseEnter: options.onMouseEnter,
            onMouseLeave: options.onMouseLeave,
            selection: options.selection
          });
        }));
      }
  }
}

exports.renderGraphicalElementSVG = renderGraphicalElementSVG;

var GraphicalElementDisplay =
/*#__PURE__*/
function (_React$PureComponent2) {
  _inherits(GraphicalElementDisplay, _React$PureComponent2);

  function GraphicalElementDisplay() {
    _classCallCheck(this, GraphicalElementDisplay);

    return _possibleConstructorReturn(this, _getPrototypeOf(GraphicalElementDisplay).apply(this, arguments));
  }

  _createClass(GraphicalElementDisplay, [{
    key: "render",
    value: function render() {
      return renderGraphicalElementSVG(this.props.element);
    }
  }]);

  return GraphicalElementDisplay;
}(React.PureComponent);

exports.GraphicalElementDisplay = GraphicalElementDisplay;